module.exports = __webpack_public_path__ + "static/media/11.f3a93634.jpg";